import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Auth, Hub } from 'aws-amplify';
import './App.css';
import Home from './features/home/Home';
import Header from './features/header/Header';
import Footer from './features/footer/Footer';
import Projects from './features/projects/Projects';
import Training from './features/training/Training';
import CodeDevelopment from './features/codeDevelopment/CodeDevelopment';
import References from './features/references/References';
import Page from './features/page/Page';
import Help from './features/help/Help';
import { AuthContext } from './features/auth/context/auth';
import PrivateRoute from './features/auth/PrivateRoute';
import Login from './features/auth/Login';
import ScrollToTop from './features/scrollToTop/ScrollToTop';
import getEnvVarValue, {COGNITO_USER_POOL_ID, COGNITO_CLIENT_ID, COGNITO_DOMAIN, COGNITO_CALLBACK_URL} from './functions/getEnvVarValue';

function App() {
  const existingUser = JSON.parse(localStorage.getItem('mdaqrt_user'));
  const [user, setUser] = useState(existingUser);
  const existingUserAttributes = JSON.parse(
    localStorage.getItem('mdaqrt_user_attributes')
  );
  const [userAttributes, setUserAttributes] = useState(existingUserAttributes);

  const updateUserAttributes = async () => {
    try {
      const authenticatedUser = await Auth.currentAuthenticatedUser();
      localStorage.setItem(
        'mdaqrt_user_attributes',
        JSON.stringify(authenticatedUser.attributes)
      );
      setUserAttributes(authenticatedUser.attributes);
    } catch {
      // do nothing
    }
  };

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
          localStorage.setItem('mdaqrt_user', JSON.stringify(data));
          setUser(data);
          updateUserAttributes();
          break;
        default:
      }
    });
  }, []);

  Auth.configure({
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: getEnvVarValue(COGNITO_USER_POOL_ID),
    userPoolWebClientId: getEnvVarValue(COGNITO_CLIENT_ID),

    // Cognito Hosted UI configuration
    oauth: {
      domain: getEnvVarValue(COGNITO_DOMAIN),
      scope: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
      redirectSignIn: getEnvVarValue(COGNITO_CALLBACK_URL),
      redirectSignOut: getEnvVarValue(COGNITO_CALLBACK_URL),
      responseType: 'code',
    },
  });
  return (
    <AuthContext.Provider
      value={{
        user,
        userAttributes,
      }}
    >
      <Router>
        <ScrollToTop />
        <div className="site">
          <Header />
          <div className="content">
            <Switch>
              <Route path="/login" component={Login} />
              <PrivateRoute exact path="/" component={Home} />
              <PrivateRoute exact path="/page" component={Page} />
              <PrivateRoute exact path="/projects" component={Projects} />
              <PrivateRoute exact path="/training" component={Training} />
              <PrivateRoute exact path="/code-development" component={CodeDevelopment} />
              <PrivateRoute exact path="/references" component={References} />
              <PrivateRoute exact path="/help" component={Help} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
